/**
 * MOCK_TEMPLATES — fallback copies of the Jerny.CsCodeTemplates notes.
 * Used by CsCodeTemplateEngine only when the BE cache is empty (not yet fetched / offline dev).
 * These MUST stay in sync with the real notes in Jerny.CsCodeTemplates — source of truth is the notes,
 * this file is a convenience mirror so the widget works before fetchAll() has run.
 *
 * No `using` statement is ever hardcoded here (correction 20260701) — every code file's usings come
 * from %BASE_USINGS% (System, System.Linq etc, form-editable) + %CUSTOM_USINGS% (KD8/Treetek specific).
 *
 * Note RKs (Jerny.CsCodeTemplates):
 * PluginClass=310fc30de9dd4942b5d6f802bb2f14dc, PluginContext=f18fe066ddce49a78e8399b71af307ab,
 * PluginConfigurator=9b64a520a8c540e983f2f1d9d4e89097, PluginContainerModule=a3646243f840410eb638b7bac902133a,
 * PluginEngineRunner=ba0aa8c893524cd7a005d2cd96ab0e52,
 * PluginCsproj=ea87d5c1c8884750932395015dfcf2cb, DataDbContext=a2cca0c44b6d4d76a145efab0c3923be,
 * DataDbConnection=a87ce5e5d64847d2b9324acf927ed46f (moved to Data.Schema bucket 20260809),
 * DataContainerModule=f1d550cf0d2643ef90dfbd4576b9ba8b,
 * DataEfCommands=c809959d95f84f64955a02ca8278acdb, DataCsproj=b410b4617e6540878d7863a735daa394,
 * DataSchemaCsproj=59481a565fd840b88609da81b4c67ea8, SchemaContainerModule=1bc7e79a9dd749fdb2a279f267aa8bee,
 * CommonCsproj=4e1fde2218414674a8431c8cd4ed96f9,
 * ContractsContainerModule=5b60679c82674581b546a298b04842c9, ContractsEvents=48d02bdd0d724cf2b39acaaa6bc63381,
 * ContractsItem=3f9ff3deb1684f398a5901cce77bdc53, ContractsQueue=dbff988a65324801b0a0ef482253bc1d,
 * ContractsQueueCreator=8eec99ae1d6e4b2a8c7413617280920a, ContractsQueueEvent=d3c9ebf317364f2f897bccde8e1233af,
 * ContractsQueuePublisher=27a47d5914394d75a43c7af0b2f01e15, ContractsCsproj=c752a1342e1b4458b7d5e89322482e0b,
 * ContractsEventBuffer=fef875952108430a9eea02c4af4b8866, ContractsEventHandlerBase=22157487cae94c5eb59ba5fac5caa6e6,
 * ContractsEventHandlerSelector=0daebdb384c841579705abefc3a33e28, ContractsEventCatcher=b5d56b636c914e04ba366520670e0337,
 * TestsCsproj=8e06a3785a1f4a36bc30af661b45d16d, appsettings=edcbef3438bc4854a14d649039b725d6,
 * nlog=dd2602057e1749b6ac41e21a5b305400 (renamed from TestsAppSettings/TestsNlogConfig 20260809
 * so the derived fileName matches TestsCsproj's <None Update="appsettings.json"/"nlog.config">)
 */
export const MOCK_TEMPLATES = {
    PluginClass: `%BASE_USINGS%
%CUSTOM_USINGS%

namespace %PREFIX%.%PROJECT_NAME%.Plugin
{
    public interface I%PLUGIN_NAME%Plugin : IEnginePlugin
    {

    }


    public class %PLUGIN_NAME%Plugin : EnginePluginBase<I%PLUGIN_NAME%PluginContext>, I%PLUGIN_NAME%Plugin
    {
        private readonly I%PLUGIN_NAME%PluginContext _ctx;


        private readonly IEpochHelper _ep;


        public %PLUGIN_NAME%Plugin(
            I%PLUGIN_NAME%PluginContext ctx,

            IEpochHelper ep,
            ILogHandler logHandler
        ) : base(ctx, logHandler)
        {
            _ctx = GetContext();
            _ctx.Active = true;

            _ep = ep;
        }



        public override int Initialize(IAppSettings app)
        {
            var r = base.Initialize(app);
            if (r < 0) return r;

            // TODO: initialize dependencies here

            return r;
        }


        public override async Task<int> Bootup()
        {
            if (!_ctx.Active) return 0;
            var r = await base.Bootup();

            if (r < 0) return r;

            // TODO: bootup logic here

            return r;
        }




        public override Task<int> Run()
        {
            if (!_ctx.Active) return Task.FromResult(0);
            var r = base.Run();

            // TODO: run logic here

            return r;
        }



        public override async Task<int> Cleanup()
        {
            if (!_ctx.Active) return 0;
            var r = await base.Cleanup();

            // TODO: cleanup logic here

            return r;
        }
    }
}
`,

    PluginContext: `%BASE_USINGS%
%CUSTOM_USINGS%

namespace %PREFIX%.%PROJECT_NAME%.Plugin
{
    public interface I%PLUGIN_NAME%PluginContext : IEnginePluginContext
    {

        /// <summary>
        /// TODO: describe target service(s) for updates
        /// </summary>
        List<string> Targets { get; set; }


        /// <summary>
        /// delay time in ms for processing
        /// buffered rest request
        /// </summary>
        int RestDelay { get; set; }


        /// <summary>
        /// The app name for values
        /// </summary>
        string AppName { get; set; }

    }


    public class %PLUGIN_NAME%PluginContext : EnginePluginContextBase, I%PLUGIN_NAME%PluginContext
    {
        public List<string> Targets { get; set; } = [];

        public string AppName { get; set; }

        public int RestDelay { get; set; } = 500;

    }
}
`,

    PluginConfigurator: `%BASE_USINGS%
%CUSTOM_USINGS%

namespace %PREFIX%.%PROJECT_NAME%.Plugin.Utils
{



    /// <summary>
    /// configurator for %PLUGIN_NAME% Engine plugin
    /// </summary>
    public interface I%PLUGIN_NAME%PluginConfigurator : IPluginConfigurator
    {
    }



    public class %PLUGIN_NAME%PluginConfigurator : ConfiguratorBase<I%PLUGIN_NAME%PluginContext>, I%PLUGIN_NAME%PluginConfigurator
    {

        public %PLUGIN_NAME%PluginConfigurator(
            I%PLUGIN_NAME%PluginContext ctx,


            ILogHandler logHandler
        ) : base(ctx, logHandler)
        {
            Init(this, logHandler);
        }



        /// <summary>
        /// configure plugin context
        /// </summary>
        /// <returns></returns>
        public IEnginePluginContext Configure()
        {

            // TODO: set active flag / app name / target services
            _ctx.Active = true;
            _ctx.AppName = "%PROJECT_NAME%";

            // TODO: set target service for RT updates
            // _ctx.Targets.Add("PortalService");



            return _ctx;
        }

    }
}
`,

    PluginContainerModule: `%BASE_USINGS%
%CUSTOM_USINGS%

namespace %PREFIX%.%PROJECT_NAME%.Plugin
{
    public class ContainerModule : ContainerModuleBase2
    {

        public override Container RegisterTo(
            Container container,
            LifeStyleTarget lifeStyleTarget,
            IAppSettings app,
            IConfigurationRoot config
        )
        {

            base.RegisterTo(container, lifeStyleTarget, app, config);

            new ConventionBindingBuilder(container)
                .FromThisAssembly()
                .SelectAllClasses()

                .Excluding<IEnginePluginContext>()
                .Excluding<IInjectionIgnored>()

                .BindDefaultInterface(lifeStyleTarget);

            container.RegisterFunc<I%PLUGIN_NAME%PluginContext>();


            return container;
        }
    }
}
`,

    PluginEngineRunner: `%BASE_USINGS%
%CUSTOM_USINGS%

namespace %PREFIX%.%PROJECT_NAME%.Plugin
{

    public interface IEngineRunner : IEngineLoopBase
    {

    }

    public class EngineRunner : EngineLoopBase, IEngineRunner
    {

        public EngineRunner(


            ILogHandler logHandler
            ) : base(logHandler)
        {

            Init(this, logHandler);
        }

    }
}
`,

    PluginCsproj: `\uFEFF<Project Sdk="Microsoft.NET.Sdk">

  <PropertyGroup>
    <TargetFramework>net8.0</TargetFramework>
    <ImplicitUsings>enable</ImplicitUsings>
    <Nullable>disable</Nullable>

    <AssemblyName>$(MSBuildProjectName)</AssemblyName>
    <PackageId>$(MSBuildProjectName)</PackageId>
    <Description>%DESCRIPTION%</Description>
    <Copyright>2026 treetek</Copyright>
    <Company>treetek</Company>
    <Authors>%AUTHOR%</Authors>
    <GenerateDocumentationFile>true</GenerateDocumentationFile>
    <GeneratePackageOnBuild>false</GeneratePackageOnBuild>

  </PropertyGroup>


  <PropertyGroup>
    <WarningsAsErrors>$(WarningsAsErrors);NU1605</WarningsAsErrors>
    <NoWarn>1591</NoWarn>
    <RootNamespace>$(MSBuildProjectName.Replace(" ", "_"))</RootNamespace>
  </PropertyGroup>


  <ItemGroup>
%PACKAGE_REFERENCES%
  </ItemGroup>


  <ItemGroup>
%PROJECT_REFERENCES%
  </ItemGroup>


</Project>
`,

    DataDbContext: `%BASE_USINGS%
%CUSTOM_USINGS%

namespace %PREFIX%.%PROJECT_NAME%.Data.Plugin
{


    public interface I%PREFIX%%PROJECT_NAME%DbContext : IDbContextEF
    {
    }

    public class %PREFIX%%PROJECT_NAME%DbContext : DbContext, I%PREFIX%%PROJECT_NAME%DbContext
    {
        public int Order { get; set; } = 10;

        public string ConnectionStr { get; set; }



        // TODO: add your DbSet properties here, e.g.:
        // /// <summary>
        // /// Holds MyEntity records
        // /// </summary>
        // public DbSet<MyEntity> MyEntities { get; set; }





        /// <summary>
        /// override static interface method for IServiceCollection AddDbContext
        /// </summary>
        /// <param name="s">the connection str </param>
        /// <returns></returns>
        public static Action<DbContextOptionsBuilder> CreateOptionBuilderAction(string s)
        {
            return o => Bme6MigratorBase.CreateContextOptionBuilder<%PREFIX%%PROJECT_NAME%DbContext>(s);
        }

        /// <summary>
        /// override static interface method for IServiceCollection AddDbContext
        /// </summary>
        /// <param name="connectionStr"></param>
        /// <returns></returns>
        public static IDbContextEF CreateContext(string connectionStr)
        {
            var opt = Bme6MigratorBase.CreateContextOptionBuilder<%PREFIX%%PROJECT_NAME%DbContext>(connectionStr);
            var db03 = new %PREFIX%%PROJECT_NAME%DbContext(opt.Options);
            db03.ConnectionStr = connectionStr;

            return db03;
        }







        public %PREFIX%%PROJECT_NAME%DbContext()
        {

        }

        public %PREFIX%%PROJECT_NAME%DbContext(DbContextOptions<%PREFIX%%PROJECT_NAME%DbContext> options)
            : base(options)
        {
        }

        protected override void OnConfiguring(DbContextOptionsBuilder optionsBuilder)
        {
            if (optionsBuilder.IsConfigured) return;

            if (string.IsNullOrEmpty(ConnectionStr))
            {
                Console.WriteLine($"%PREFIX%%PROJECT_NAME%DbContext.OnConfigure: Using Bme6MigratorBase ConStr");
                ConnectionStr = Bme6MigratorBase.ConnectionStr;
            }

            optionsBuilder.UseMySql(ConnectionStr, Bme6MigratorBase.GetMySqlVersion());
        }



    }
}
`,

    DataDbConnection: `%BASE_USINGS%
%CUSTOM_USINGS%

namespace %PREFIX%.%PROJECT_NAME%.Data.Schema
{
    public interface I%PREFIX%%PROJECT_NAME%DbConnection : IServiceDbConnectionBase
    {
    }

    public class %PREFIX%%PROJECT_NAME%DbConnection : ServiceDbConnectionBase, I%PREFIX%%PROJECT_NAME%DbConnection
    {

        public %PREFIX%%PROJECT_NAME%DbConnection()
        {

        }

        public %PREFIX%%PROJECT_NAME%DbConnection(
            string connectionStr,
            IDbConnectionFactory factory,
            ILogHandler logger
        )
            : base(factory, logger)
        {
            ConnectionStr = connectionStr;
        }


    }
}
`,

    DataContainerModule: `%BASE_USINGS%
%CUSTOM_USINGS%

namespace %PREFIX%.%PROJECT_NAME%.Data.Plugin
{
    public class ContainerModule : ContainerModuleBase2
    {

        public override Container RegisterTo(
            Container container,
            LifeStyleTarget lifeStyleTarget,
            IAppSettings app,
            IConfigurationRoot config
        )
        {

            base.RegisterTo(container, lifeStyleTarget, app, config);

            new ConventionBindingBuilder(container)
                .FromThisAssembly()
                .SelectAllClasses()

                .Excluding<IInjectionIgnored>()

                .BindAllInterfaces(lifeStyleTarget);


            var r = RegisterDbConnection<%PREFIX%%PROJECT_NAME%DbConnection>();


            return container;
        }


        private new int RegisterDbConnection<TInstance>(string tag = "")
              where TInstance : class, IServiceDbConnectionBase, new()
        {
            if (string.IsNullOrEmpty(tag))
                tag = typeof(TInstance).Name;


            var conStr = AppSettings.GetConnectionStr($"%{tag}%");
            if (string.IsNullOrEmpty(conStr))
            {
                AppSettings.Logger.Log(LogLevel.Fatal, $"Missing connection string {tag}!");
                return -1;
            }

            var p1 = new TInstance();
            p1.ConnectionStr = conStr;
            p1.Set(new MySqlConnectionFactory(), AppSettings.Logger);

            if (AppSettings.AddonTypes == null || AppSettings.AddonTypes.Count == 0)
            {
                AppSettings.Logger.Log(LogLevel.Fatal, "AddonTypes types not resolved!");
                return -1;
            }

            var iType = $"I{typeof(TInstance).Name}";
            var interfaceType = AppSettings.AddonTypes.FirstOrDefault(x => x.Name == iType);
            if (interfaceType == null)
            {
                AppSettings.Logger.Log(LogLevel.Fatal, $"Missing interface type {tag}!");
                return -1;
            }


            _container.RegisterSingleton(interfaceType, () => p1);


            return 0;
        }
    }
}
`,

    SchemaContainerModule: `%BASE_USINGS%
%CUSTOM_USINGS%
using Microsoft.Extensions.Configuration;
using NLog;
using SimpleInjector;
using Treetek.net8.Core.Bootstrapper;
using Treetek.net8.Data.DapperCore;

namespace %PREFIX%.%PROJECT_NAME%.Data.Schema
{
    public class ContainerModule : ContainerModuleBase2
    {

        public override Container RegisterTo(
            Container container,
            LifeStyleTarget lifeStyleTarget,
            IAppSettings app,
            IConfigurationRoot config
        )
        {

            base.RegisterTo(container, lifeStyleTarget, app, config);

            new ConventionBindingBuilder(container)
                .FromThisAssembly()
                .SelectAllClasses()

                .Excluding<IInjectionIgnored>()

                .BindAllInterfaces(lifeStyleTarget);


            var conStr = app.GetConnectionStr($"%{nameof(%PREFIX%%PLUGIN_NAME%DbConnection)}%");
            if (string.IsNullOrEmpty(conStr))
            {
                app.Logger.Log(LogLevel.Fatal, $"%PREFIX%.%PROJECT_NAME%.Data.Schema.ContainerModule.{nameof(RegisterTo)}: Empty connection string");
            }

            var p1 = new %PREFIX%%PLUGIN_NAME%DbConnection(conStr, new MySqlConnectionFactory(), app.Logger);
            container.RegisterSingleton<I%PREFIX%%PLUGIN_NAME%DbConnection>(() => p1);


            return container;
        }
    }
}
`,

    ContractsContainerModule: `%BASE_USINGS%
using Microsoft.Extensions.Configuration;
using SimpleInjector;
using Treetek.net8.Core.AppManagement;
using Treetek.net8.Core.Bootstrapper;

namespace %PREFIX%.%PROJECT_NAME%.Contracts
{
    public class ContainerModule : ContainerModuleBase
    {
        public override Container RegisterTo(Container container, LifeStyleTarget lifeStyleTarget, IAppSettings app, IConfigurationRoot config)
        {
            base.RegisterTo(container, lifeStyleTarget, app, config);

            new ConventionBindingBuilder(container)
                .FromThisAssembly()
                .SelectAllClasses()

                .BindDefaultInterface(lifeStyleTarget);

            return container;
        }
    }
}
`,

    ContractsEvents: `%BASE_USINGS%

namespace %PREFIX%.%PROJECT_NAME%.Contracts.Utils.Rmq;


public enum %PLUGIN_NAME%Events
{
    Unknown = 0,

    On%PLUGIN_NAME%ItemsRequested = 100,
    On%PLUGIN_NAME%ItemsUpdated = 101,

}


public static class %PLUGIN_NAME%RoutingKeys
{
    public const string Consumers = "Consumers";
}
`,

    ContractsItem: `%BASE_USINGS%
using Newtonsoft.Json;
using Treetek.net8.Core.Models;
using Treetek.net8.Core.Utils;

namespace %PREFIX%.%PROJECT_NAME%.Contracts.Utils.Rmq;


/// <summary>
/// Holds %PLUGIN_NAME% RMQ data
/// </summary>
[JsonObject(ItemNullValueHandling = NullValueHandling.Ignore)]
public class %PLUGIN_NAME%Item  // : IRowKeyData
{

    public EventOpt EventOpt { get; set; }



    public %PLUGIN_NAME%Item CopyFrom(%PLUGIN_NAME%Item d)
    {
        // d.Id = Id;

        // EventOpt = d.EventOpt;

        return d;
    }


    public bool IsTheSame(%PLUGIN_NAME%Item d)
    {
        // d.Id = Id;

        // d.EventOpt = s.EventOpt;

        return true;
    }


    public bool IsDifferent(%PLUGIN_NAME%Item s)
    {
        // d.Id = Id;

        // d.EventOpt = s.EventOpt;

        return false;
    }

}
`,

    ContractsQueue: `%BASE_USINGS%
using System.Collections.Generic;
using Easy.MessageHub;
using Newtonsoft.Json;
using NLog;
using RabbitMQ.Client;
using Treetek.net8.Connectivity.RMQ.SystemQueueManagement;
using Treetek.net8.Connectivity.RMQ.Utils;
using Treetek.net8.Core.AppManagement;
using Treetek.net8.Core.Bootstrapper;
using Treetek.net8.Core.Interfaces;
using Treetek.net8.Core.Models;
using Treetek.net8.Core.Utils;

// ReSharper disable MemberCanBePrivate.Global

namespace %PREFIX%.%PROJECT_NAME%.Contracts.Utils.Rmq
{
    /// <summary>
    /// The queue creator for each Log / instance
    /// </summary>
    public interface I%PLUGIN_NAME%Queue : IRabbitBase, ISingleton
    {
        /// <summary>
        /// True when this host runs the %PLUGIN_NAME% plugin (producer side)
        /// </summary>
        bool IsOwner { get; set; }
    }


    /// <summary>
    /// send %PLUGIN_NAME% data to queue
    /// </summary>
    public class %PLUGIN_NAME%Queue : RabbitBase, I%PLUGIN_NAME%Queue
    {
        public bool IsOwner { get; set; }


        public %PLUGIN_NAME%Queue(
            IMessageHub messageHub,
            ISecretContainer secretContainer,
            ILogHandler logHandler
        ) : base(messageHub, secretContainer)
        {
            Init(this, logHandler);
        }




        public override RabbitContext CreateContext(IAppSettings app, bool isPublisherOnly = true)
        {
            var r = base.CreateContext(app, isPublisherOnly);

            // create possible routing keys
            _routingKeys.Add(new RoutingKey { Id = %PLUGIN_NAME%RoutingKeys.Consumers, Active = true, Description = "For all generic messages" });


            r.IsPublisherOnly = isPublisherOnly;

            // this queue is also a publisher
            // for broadcasting system messages
            r.ExchangeCreate = true;
            r.ExchangeType = "direct";
            r.ExchangeDurable = true;
            r.ExchangeAutoDelete = false;


            // keep the queue
            r.RemoveQueue = false;
            r.IsDurable = false;
            r.Persistent = false;
            r.TTLInSec = 30;

            //r.LogPublish = false;
            //r.LogReceived = false;
            return r;
        }


        protected override int DeclareQueues(Dictionary<string, object> args, string banner)
        {
            var r = base.DeclareQueues(args, banner);
            if (r < 0) return r;

            try
            {
                // owner never binds consumer keys, so it can't receive its own broadcasts
                var f = Consumers.FirstOrDefault(x => x == _app.App);
                if (!IsOwner && f != null)
                {
                    OnActiveRoutingKeys(this, _routingKeys);

                    foreach (var rk in _routingKeys)
                    {
                        if (!rk.Active) continue;

                        _ci.Channel.QueueBind(queue: _ctx.QueueName, exchange: _ctx.ExchangeName, routingKey: rk.Id);
                    }
                }

                // this instance specifically, for update requests
                _ci.Channel.QueueBind(queue: _ctx.QueueName, exchange: _ctx.ExchangeName, routingKey: _app.Instance);

                // requests for the plugin, independent of which service hosts it
                if (IsOwner)
                {
                    _ci.Channel.QueueBind(queue: _ctx.QueueName, exchange: _ctx.ExchangeName, routingKey: "%PLUGIN_NAME%");
                }

                return 0;
            }
            catch (Exception ex)
            {
                _logHandler.Log(LogLevel.Fatal, ex, $"{_name}.Declare: e={ex}");
                return -1;
            }

        }




        /// <summary>
        /// Overwrite PublishEventType to convert received message into %PLUGIN_NAME%QueueEvent
        ///
        /// <para>
        /// Converted messages are broadcast using IMessageHub for processing
        /// in sub systems
        /// </para>
        ///
        /// </summary>
        /// <param name="message"></param>
        protected override void PublishEventType(string message)
        {
            try
            {
                var data = JsonConvert.DeserializeObject<%PLUGIN_NAME%QueueEvent>(message);
                _messageHub.PublishAsync(data);
            }
            catch (Exception ex)
            {
                _logHandler.Log(LogLevel.Fatal, ex, $"{_name}.PublishEventType: ex={ex}");
            }
        }


        public override int Cleanup()
        {
            return base.Cleanup();
        }
    }
}
`,

    ContractsQueueCreator: `%BASE_USINGS%
using System.Threading.Tasks;
using Treetek.net8.Connectivity.RMQ.SystemQueueManagement;
using Treetek.net8.Core.Bootstrapper;

// ReSharper disable MemberCanBePrivate.Global

namespace %PREFIX%.%PROJECT_NAME%.Contracts.Utils.Rmq
{

    public interface I%PLUGIN_NAME%QueueCreator : IQueueCreatorBase<I%PLUGIN_NAME%Queue, %PLUGIN_NAME%Queue>
    {
        I%PLUGIN_NAME%QueuePublisher Publisher { get; set; }

        /// <summary>
        /// True when this host runs the %PLUGIN_NAME% plugin, passed on to the queue
        /// </summary>
        bool IsOwner { get; set; }
    }



    /// <summary>
    /// Creates the %PLUGIN_NAME% queue + publisher.
    ///
    /// <para>
    /// Register in the service's InitializeQueueFactory:
    /// </para>
    /// <code>
    /// // host of the plugin
    /// _queueFactory.Creators.Add(new QueueCreator { Instance = new %PLUGIN_NAME%QueueCreator { IsOwner = true }, IsPublisherOnly = false });
    ///
    /// // every other service that only listens
    /// _queueFactory.Creators.Add(new QueueCreator { Instance = new %PLUGIN_NAME%QueueCreator(), IsPublisherOnly = false });
    /// </code>
    /// </summary>
    public class %PLUGIN_NAME%QueueCreator : QueueCreatorBase<I%PLUGIN_NAME%Queue, %PLUGIN_NAME%Queue>, I%PLUGIN_NAME%QueueCreator
    {
        public I%PLUGIN_NAME%QueuePublisher Publisher { get; set; }

        public bool IsOwner { get; set; }



        /// <summary>
        /// Creates the queue and all it's dependencies
        /// </summary>
        /// <param name="bs"></param>
        /// <param name="banner"></param>
        /// <param name="isPublisherOnly"></param>
        /// <returns></returns>
        public override async Task<I%PLUGIN_NAME%Queue> Create(IBootstrapper bs, string banner = "", bool isPublisherOnly = false)
        {
            Queue = await base.Create(bs, banner, isPublisherOnly);

            // must be set before Initialize, DeclareQueues depends on it
            Queue.IsOwner = IsOwner;

            Publisher ??= new %PLUGIN_NAME%QueuePublisher(Queue, _bs.Logger);
            Publisher.Initialize(bs.AppCtx);

            Queue.Initialize(_bs.AppCtx, isPublisherOnly, autoStartConsumer: false, banner);
            return Queue;
        }

        public override int RegisterComponents()
        {
            _bs.Container.RegisterSingleton(() => Queue);
            _bs.Container.RegisterSingleton(() => Publisher);

            return 0;
        }
    }
}
`,

    ContractsQueueEvent: `%BASE_USINGS%
using Treetek.net8.Connectivity.RMQ.Utils;

namespace %PREFIX%.%PROJECT_NAME%.Contracts.Utils.Rmq
{
    public class %PLUGIN_NAME%QueueEvent : QueueEventBase<%PLUGIN_NAME%Item>
    {

    }
}
`,

    ContractsQueuePublisher: `%BASE_USINGS%
using Treetek.net8.Connectivity.RMQ.Utils;
using Treetek.net8.Core.Interfaces;

namespace %PREFIX%.%PROJECT_NAME%.Contracts.Utils.Rmq
{

    /// <summary>
    /// The plain RMQ publisher
    ///
    /// <para>
    /// Do not add domain, data or other package components!
    /// %PLUGIN_NAME%.Contracts must be as slim as possible
    /// </para>
    ///
    /// </summary>
    public interface I%PLUGIN_NAME%QueuePublisher : IRabbitPublisherBase<%PLUGIN_NAME%Item, %PLUGIN_NAME%QueueEvent>
    {
    }


    public class %PLUGIN_NAME%QueuePublisher : RabbitPublisherBase<%PLUGIN_NAME%Item, %PLUGIN_NAME%QueueEvent>, I%PLUGIN_NAME%QueuePublisher
    {
        public %PLUGIN_NAME%QueuePublisher(
            I%PLUGIN_NAME%Queue queue,


            ILogHandler logger
            ) : base(queue, logger)
        {
            Init(this, logger);
        }


    }
}
`,

    ContractsEventBuffer: `%BASE_USINGS%
using %PREFIX%.%PROJECT_NAME%.Contracts.Utils.Rmq;
using Treetek.net8.Core.Interfaces;
using Treetek.net8.Core.Utils;

namespace %PREFIX%.%PROJECT_NAME%.Contracts.EventManagement
{
    /// <summary>
    /// for caching / queueing rest request 
    /// </summary>
    public interface I%PLUGIN_NAME%QueueEventBuffer : ICacheQueue<%PLUGIN_NAME%QueueEvent>
    {

    }


    public class %PLUGIN_NAME%QueueEventBuffer : CacheQueue<%PLUGIN_NAME%QueueEvent>, I%PLUGIN_NAME%QueueEventBuffer
    {
        public %PLUGIN_NAME%QueueEventBuffer(ILogHandler logHandler) : base(logHandler)
        {

        }
    }
}
`,

    ContractsEventHandlerBase: `%BASE_USINGS%
using System.Threading.Tasks;
using %PREFIX%.%PROJECT_NAME%.Contracts.Utils.Rmq;
using Treetek.net8.Core.AppManagement;
using Treetek.net8.Core.Interfaces;
using Treetek.net8.Core.Models;

namespace %PREFIX%.%PROJECT_NAME%.Contracts.EventManagement
{
    public interface I%PLUGIN_NAME%QueueEventHandler : ICoreBase2, ISingleton
    {
        /// <summary>
        /// the action name aka %PLUGIN_NAME%QueueModified
        /// </summary>
        string Action { get; }


        /// <summary>
        /// Buffer count 
        /// </summary>
        int Count { get; }

        /// <summary>
        /// initialize event handlers 
        /// </summary>
        /// <param name="app"></param>
        /// <returns></returns>
        int Initialize(IAppSettings app);

        /// <summary>
        /// execute event 
        /// </summary>
        /// <param name="obj"></param>
        /// <returns></returns>
        Task<int> Handle(%PLUGIN_NAME%QueueEvent obj);


        /// <summary>
        /// process buffered items
        /// </summary>
        /// <param name="delay"></param>
        /// <returns></returns>
        Task<int> Run(int delay);



        /// <summary>
        /// Enqueue directly on handler self 
        /// </summary>
        /// <param name="obj"></param>
        /// <returns></returns>
        int Enqueue(%PLUGIN_NAME%QueueEvent obj);


        int Cleanup();

    }


    public abstract class %PLUGIN_NAME%QueueEventHandlerBase : CoreBase2, I%PLUGIN_NAME%QueueEventHandler
    {
        protected IAppSettings _app;
        protected readonly %PLUGIN_NAME%QueueEventBuffer _buffer;


        public string Action { get; protected set; }

        public int Count => _buffer.Count;


        protected %PLUGIN_NAME%QueueEventHandlerBase(
            ILogHandler logHandler
        )
        {
            Init(this, logHandler);


            _buffer = new %PLUGIN_NAME%QueueEventBuffer(_logHandler);

        }

        public virtual int Initialize(IAppSettings app)
        {
            if (_app != null)
                return 0;

            _app = app;

            return 0;
        }

        public virtual Task<int> Handle(%PLUGIN_NAME%QueueEvent obj)
        {
            return Task.FromResult(100);
        }



        public int Enqueue(%PLUGIN_NAME%QueueEvent obj)
        {
            if (obj == null) return -1;

            _buffer.Enqueue(obj);
            return 0;
        }

        public virtual int Cleanup()
        {
            return 0;
        }


        public abstract Task<int> Run(int delay);


    }
}
`,

    ContractsEventHandlerSelector: `%BASE_USINGS%
using System.Collections.Generic;
using NLog;
using Treetek.net8.Core.AppManagement;
using Treetek.net8.Core.Interfaces;
using Treetek.net8.Core.Models;

namespace %PREFIX%.%PROJECT_NAME%.Contracts.EventManagement
{
    public interface I%PLUGIN_NAME%QueueEventHandlerSelector : ICoreBase2, ISingleton
    {
        int Initialize(IAppSettings app);


        I%PLUGIN_NAME%QueueEventHandler Select(string action);
    }
    public class %PLUGIN_NAME%QueueEventHandlerSelector : CoreBase2, I%PLUGIN_NAME%QueueEventHandlerSelector
    {
        private readonly List<I%PLUGIN_NAME%QueueEventHandler> _handlers;
        private IAppSettings _app;

        public %PLUGIN_NAME%QueueEventHandlerSelector(
            IEnumerable<I%PLUGIN_NAME%QueueEventHandler> handlers,
            ILogHandler logHandler
            )
        {

            _handlers = handlers.ToList();

            Init(this, logHandler);
        }


        public int Initialize(IAppSettings app)
        {
            if (_app != null)
                return 0;

            _app = app;

            _handlers.ForEach(x => x.Initialize(_app));


            return 0;
        }


        public I%PLUGIN_NAME%QueueEventHandler Select(string action)
        {
            var handler = _handlers.FirstOrDefault(x => x.Action == action);
            if (handler != null) return handler;

            _logHandler.Log(LogLevel.Error, $"{_name}.{nameof(Select)}: Handler not found: {action}");
            return null;
        }
    }
}
`,

    ContractsEventCatcher: `%BASE_USINGS%
using System.Collections.Generic;
using System.Threading.Tasks;
using %PREFIX%.%PROJECT_NAME%.Contracts.Utils.Rmq;
using KD8.Common.Contracts.Utils;
using Treetek.net8.Core.AppManagement;
using Treetek.net8.Core.Interfaces;

namespace %PREFIX%.%PROJECT_NAME%.Contracts.EventManagement
{
    /// <summary>
    /// Catch %PLUGIN_NAME%QueueEvents from external services
    ///
    /// reg singletons for %PLUGIN_NAME%QueueEvent handlers
    ///
    /// container.RegisterSelectorTypes<I%PLUGIN_NAME%QueueEventHandler>();
    /// </summary>
    public interface I%PLUGIN_NAME%QueueEventCatcher : IEngineLoopHandler
    {

    }


    public class %PLUGIN_NAME%QueueEventCatcher : EngineLoopHandlerBase<%PLUGIN_NAME%QueueEventBuffer>, I%PLUGIN_NAME%QueueEventCatcher
    {
        private readonly I%PLUGIN_NAME%QueueEventHandlerSelector _selector;
        private readonly IEnumerable<I%PLUGIN_NAME%QueueEventHandler> _handlers;

        public %PLUGIN_NAME%QueueEventCatcher(
            I%PLUGIN_NAME%QueueEventHandlerSelector selector,
            IEnumerable<I%PLUGIN_NAME%QueueEventHandler> handlers,
            ILogHandler logHandler
            ) : base(logHandler)
        {
            _selector = selector;
            _handlers = handlers;

            Init(this, logHandler);
        }


        public override async Task<int> Initialize(IAppSettings app)
        {
            // call base for ini _app and creation of event subscriber 
            var r = await base.Initialize(app);
            if (r < 0) return r;

            // initialize injected request handlers 
            _handlers.ToList().ForEach(x => _ = x.Initialize(app));

            // create internal queue
            _buffer = new %PLUGIN_NAME%QueueEventBuffer(_logHandler);

            _subscriber.Subscribe<%PLUGIN_NAME%QueueEvent>(p =>
            {
                if (p == null) return;

                // TODO: dispatch per event, e.g. _selector.Select(action: ...)?.Enqueue(p);
            });

            return 0;
        }


        /// <summary>
        /// buffer contains consumer messages
        /// </summary>
        /// <param name="buffer"></param>
        /// <returns></returns>
        public override int ProcessEvent(object buffer)
        {
            return 0;
        }


        public override async Task<int> Cleanup()
        {
            var r = await base.Cleanup();

            _handlers.ToList().ForEach(x => _ = x.Cleanup());

            return r;
        }
    }
}
`,

    ContractsCsproj: `\uFEFF<Project Sdk="Microsoft.NET.Sdk">

  <PropertyGroup>
    <TargetFramework>net8.0</TargetFramework>
    <ImplicitUsings>disable</ImplicitUsings>
    <Nullable>disable</Nullable>

    <AssemblyName>$(MSBuildProjectName)</AssemblyName>
    <PackageId>$(MSBuildProjectName)</PackageId>
    <Description>%DESCRIPTION%</Description>
    <Copyright>2026 treetek</Copyright>
    <Company>treetek</Company>
    <Authors>%AUTHOR%</Authors>
    <GenerateDocumentationFile>true</GenerateDocumentationFile>
    <GeneratePackageOnBuild>false</GeneratePackageOnBuild>

  </PropertyGroup>


  <PropertyGroup>
    <WarningsAsErrors>$(WarningsAsErrors);NU1605</WarningsAsErrors>
    <NoWarn>1591</NoWarn>
    <RootNamespace>$(MSBuildProjectName.Replace(" ", "_"))</RootNamespace>
  </PropertyGroup>


  <ItemGroup>
%PACKAGE_REFERENCES%
  </ItemGroup>


  <ItemGroup>
%PROJECT_REFERENCES%
  </ItemGroup>


</Project>
`,

    DataEfCommands: `
add-migration "TODO: describe migration"  -s %HOSTED_SERVICE% -Project %PREFIX%.%PROJECT_NAME%.Data.Plugin  -Context %PREFIX%%PROJECT_NAME%DbContext


# Remove-Migration -s %HOSTED_SERVICE% -Project %PREFIX%.%PROJECT_NAME%.Data.Plugin  -Context %PREFIX%%PROJECT_NAME%DbContext
`,

    DataCsproj: `\uFEFF<Project Sdk="Microsoft.NET.Sdk">

  <PropertyGroup>
    <TargetFramework>net8.0</TargetFramework>
    <ImplicitUsings>disable</ImplicitUsings>
    <Nullable>disable</Nullable>

    <AssemblyName>$(MSBuildProjectName)</AssemblyName>
    <PackageId>$(MSBuildProjectName)</PackageId>
    <Description>%DESCRIPTION%</Description>
    <Copyright>2026 treetek</Copyright>
    <Company>treetek</Company>
    <Authors>%AUTHOR%</Authors>
    <GenerateDocumentationFile>true</GenerateDocumentationFile>
    <GeneratePackageOnBuild>false</GeneratePackageOnBuild>

  </PropertyGroup>


  <PropertyGroup>
    <WarningsAsErrors>$(WarningsAsErrors);NU1605</WarningsAsErrors>
    <NoWarn>1591</NoWarn>
    <RootNamespace>$(MSBuildProjectName.Replace(" ", "_"))</RootNamespace>
  </PropertyGroup>


  <ItemGroup>
%PACKAGE_REFERENCES%
  </ItemGroup>


  <ItemGroup>
%PROJECT_REFERENCES%
  </ItemGroup>


  <ItemGroup>
    <Folder Include="Migrations\\" />
  </ItemGroup>

</Project>
`,

    CommonCsproj: `\uFEFF<Project Sdk="Microsoft.NET.Sdk">

  <PropertyGroup>
    <TargetFramework>net8.0</TargetFramework>
    <ImplicitUsings>enable</ImplicitUsings>
    <Nullable>disable</Nullable>

    <AssemblyName>$(MSBuildProjectName)</AssemblyName>
    <PackageId>$(MSBuildProjectName)</PackageId>
    <Description>%DESCRIPTION%</Description>
    <Copyright>2026 treetek</Copyright>
    <Company>treetek</Company>
    <Authors>%AUTHOR%</Authors>
    <GenerateDocumentationFile>true</GenerateDocumentationFile>
    <GeneratePackageOnBuild>false</GeneratePackageOnBuild>

  </PropertyGroup>


  <PropertyGroup>
    <WarningsAsErrors>$(WarningsAsErrors);NU1605</WarningsAsErrors>
    <NoWarn>1591</NoWarn>
    <RootNamespace>$(MSBuildProjectName.Replace(" ", "_"))</RootNamespace>
  </PropertyGroup>


  <ItemGroup>
%PACKAGE_REFERENCES%
  </ItemGroup>


  <ItemGroup>
%PROJECT_REFERENCES%
  </ItemGroup>


</Project>
`,

    DataSchemaCsproj: `\uFEFF<Project Sdk="Microsoft.NET.Sdk">

  <PropertyGroup>
    <TargetFramework>net8.0</TargetFramework>
    <ImplicitUsings>disable</ImplicitUsings>
    <Nullable>disable</Nullable>

    <AssemblyName>$(MSBuildProjectName)</AssemblyName>
    <PackageId>$(MSBuildProjectName)</PackageId>
    <Description>%DESCRIPTION%</Description>
    <Copyright>2026 treetek</Copyright>
    <Company>treetek</Company>
    <Authors>%AUTHOR%</Authors>
    <GenerateDocumentationFile>true</GenerateDocumentationFile>
    <GeneratePackageOnBuild>false</GeneratePackageOnBuild>

  </PropertyGroup>


  <PropertyGroup>
    <WarningsAsErrors>$(WarningsAsErrors);NU1605</WarningsAsErrors>
    <NoWarn>1591</NoWarn>
    <RootNamespace>$(MSBuildProjectName.Replace(" ", "_"))</RootNamespace>
  </PropertyGroup>


  <ItemGroup>
%PACKAGE_REFERENCES%
  </ItemGroup>


  <ItemGroup>
%PROJECT_REFERENCES%
  </ItemGroup>


</Project>
`,

    TestsCsproj: `\uFEFF<Project Sdk="Microsoft.NET.Sdk">

  <PropertyGroup>
    <TargetFramework>net8.0</TargetFramework>
    <ImplicitUsings>disable</ImplicitUsings>
    <Nullable>disable</Nullable>
    <IsPackable>false</IsPackable>

    <AssemblyName>$(MSBuildProjectName)</AssemblyName>
    <PackageId>$(MSBuildProjectName)</PackageId>
    <Description>%DESCRIPTION%</Description>
    <Copyright>2026 treetek</Copyright>
    <Company>treetek</Company>
    <Authors>%AUTHOR%</Authors>
    <GenerateDocumentationFile>true</GenerateDocumentationFile>
    <GeneratePackageOnBuild>false</GeneratePackageOnBuild>

  </PropertyGroup>


  <PropertyGroup>
    <WarningsAsErrors>$(WarningsAsErrors);NU1605</WarningsAsErrors>
    <NoWarn>1591</NoWarn>
    <RootNamespace>$(MSBuildProjectName.Replace(" ", "_"))</RootNamespace>
  </PropertyGroup>


  <ItemGroup>
%PACKAGE_REFERENCES%
  </ItemGroup>


  <ItemGroup>
%PROJECT_REFERENCES%
  </ItemGroup>


  <ItemGroup>
    <None Update="appsettings.json">
      <CopyToOutputDirectory>PreserveNewest</CopyToOutputDirectory>
    </None>
    <None Update="nlog.config">
      <CopyToOutputDirectory>PreserveNewest</CopyToOutputDirectory>
    </None>
  </ItemGroup>


</Project>
`,

    appsettings: `{
  "TODO": "content nog te bepalen door Kimmie"
}
`,

    nlog: `<nlog autoReload="true" throwExceptions="true" internalLogLevel="Off" internalLogFile="\${basedir}/logs/nlog-internal.log">
  <targets>
    <target name="logfile" type="File"
            archiveNumbering="DateAndSequence"
            archiveAboveSize="10000000"
            ConcurrentWrites ="true"
            fileName="D:/LOGS/%PREFIX%.%PLUGIN_NAME%.Tests/\${date:format=yyyyMMdd}-%PREFIX%.%PLUGIN_NAME%.Tests.log"
            layout="\${date:format=yyyyMMdd}-\${time} \${uppercase:\${level}} \${message}" />
    <target name="Console"
            type="Console"
            layout="\${date:format=yyyyMMdd}-\${time} \${uppercase:\${level}} \${message}"
            detectConsoleAvailable="true" />
  </targets>
  <rules>
    <logger name="*" minlevel="Info" writeTo="logfile" />
    <logger name="*" minlevel="Debug" writeTo="Console" />
  </rules>
</nlog>
`,
};

/**
 * MOCK_TEMPLATE_RKS — strategyId -> note RK, used by CodeTemplateResolver to build fallback
 * CodeTemplateItem entries while the BE cache is empty. Same RKs as documented in the MOCK_TEMPLATES
 * header comment — kept here as actual data (not just a comment) so the resolver can use it.
 */
export const MOCK_TEMPLATE_RKS = {
    PluginClass: '310fc30de9dd4942b5d6f802bb2f14dc',
    PluginContext: 'f18fe066ddce49a78e8399b71af307ab',
    PluginConfigurator: '9b64a520a8c540e983f2f1d9d4e89097',
    PluginContainerModule: 'a3646243f840410eb638b7bac902133a',
    PluginEngineRunner: 'ba0aa8c893524cd7a005d2cd96ab0e52',
    PluginCsproj: 'ea87d5c1c8884750932395015dfcf2cb',
    DataDbContext: 'a2cca0c44b6d4d76a145efab0c3923be',
    DataDbConnection: 'a87ce5e5d64847d2b9324acf927ed46f',
    DataContainerModule: 'f1d550cf0d2643ef90dfbd4576b9ba8b',
    DataEfCommands: 'c809959d95f84f64955a02ca8278acdb',
    DataCsproj: 'b410b4617e6540878d7863a735daa394',
    DataSchemaCsproj: '59481a565fd840b88609da81b4c67ea8',
    SchemaContainerModule: '1bc7e79a9dd749fdb2a279f267aa8bee',
    ContractsContainerModule: '5b60679c82674581b546a298b04842c9',
    ContractsEvents: '48d02bdd0d724cf2b39acaaa6bc63381',
    ContractsItem: '3f9ff3deb1684f398a5901cce77bdc53',
    ContractsQueue: 'dbff988a65324801b0a0ef482253bc1d',
    ContractsQueueCreator: '8eec99ae1d6e4b2a8c7413617280920a',
    ContractsQueueEvent: 'd3c9ebf317364f2f897bccde8e1233af',
    ContractsQueuePublisher: '27a47d5914394d75a43c7af0b2f01e15',
    ContractsEventBuffer: 'fef875952108430a9eea02c4af4b8866',
    ContractsEventHandlerBase: '22157487cae94c5eb59ba5fac5caa6e6',
    ContractsEventHandlerSelector: '0daebdb384c841579705abefc3a33e28',
    ContractsEventCatcher: 'b5d56b636c914e04ba366520670e0337',
    ContractsCsproj: 'c752a1342e1b4458b7d5e89322482e0b',
    CommonCsproj: '4e1fde2218414674a8431c8cd4ed96f9',
    TestsCsproj: '8e06a3785a1f4a36bc30af661b45d16d',
    appsettings: 'edcbef3438bc4854a14d649039b725d6',
    nlog: 'dd2602057e1749b6ac41e21a5b305400',
};

/**
 * MOCK_TEMPLATE_FORMATS — strategyId -> format (file extension), mirrors the real notes' `format`
 * field (correction 20260704h) while the BE cache is empty. Only templates that AREN'T plain .cs
 * need an entry — CodeTemplateItem defaults missing/undefined to 'cs'. The three *Csproj templates
 * are 'xml' for consistency (matches CsCodeTemplateEditorDlg.langForStrategyId's syntax highlighting
 * rule), though in practice they never go through CsCodeGenGenerator.resolveTemplateFileName/emitByRk
 * — their fileName is a hardcoded emitByTitle call, not derived from format.
 */
export const MOCK_TEMPLATE_FORMATS = {
    PluginCsproj: 'xml',
    DataCsproj: 'xml',
    DataSchemaCsproj: 'xml',
    CommonCsproj: 'xml',
    TestsCsproj: 'xml',
    ContractsCsproj: 'xml',
    appsettings: 'json',
    nlog: 'config',
    DataEfCommands: 'txt',
};

/**
 * MOCK_DEFAULTS — fallback copy of the CsCodeGenDefaults note (Jerny.CsCodeTemplates, rk=f8bebbe09214482eabed8da8c2a76af9).
 * Used by CsCodeTemplateEngine.getDefaults() only when the BE cache is empty (not yet fetched / offline dev).
 * MUST stay in sync with the real note — source of truth is the note, this is a convenience mirror.
 */
export const MOCK_DEFAULTS = {
    prefix: 'KD8',
    projectNamePlaceholder: 'MyPlugin',
    pluginNamePlaceholder: 'MyPlugin',
    descriptionPlaceholder: 'describe this plugin',
    author: 'Kim Bouwman',
    hostedServicePlaceholder: 'KD8.DataCollectorService',
    sharedPackages: [{ name: 'Treetek.net8', version: '8.0.8.114' }],
    baseUsings: ['System', 'System.Linq'],
    commonUsings: [
        'KD8.Common.Contracts.Utils',
        'KD8.Core.Exchanges.Engines.Utils',
        'Treetek.net8.Core.AppManagement',
        'Treetek.net8.Core.Interfaces',
        'Treetek.net8.Core.Utils',
    ],
    pluginProjectReferences: [
        { path: '..\\KD8.Core.Exchanges.Engines\\KD8.Core.Exchanges.Engines.csproj' },
        { path: '..\\KD8.DataEnvelope.Common\\KD8.DataEnvelope.Common.csproj' },
    ],
    dataPackageAdditions: [
        { name: 'KD8.Core.Exchanges.Data', version: '8.0.1.114' },
        { name: 'Treetek.net8.Data', version: '8.0.8.292' },
    ],
    contractsPackageAdditions: [{ name: 'Treetek.net8.Connectivity', version: '8.0.8.310' }],
    pluginFiles: [
        { templateRk: '310fc30de9dd4942b5d6f802bb2f14dc', enabled: true },
        { templateRk: '9b64a520a8c540e983f2f1d9d4e89097', enabled: true },
        { templateRk: 'f18fe066ddce49a78e8399b71af307ab', enabled: true },
        { templateRk: 'a3646243f840410eb638b7bac902133a', enabled: true },
        { templateRk: 'ba0aa8c893524cd7a005d2cd96ab0e52', enabled: true },
    ],
    dataFiles: [
        { templateRk: 'a2cca0c44b6d4d76a145efab0c3923be', enabled: true },
        { templateRk: 'f1d550cf0d2643ef90dfbd4576b9ba8b', enabled: true },
        { templateRk: 'c809959d95f84f64955a02ca8278acdb', enabled: true },
    ],
    dataSchemaFiles: [
        { templateRk: 'a87ce5e5d64847d2b9324acf927ed46f', enabled: true },
        { templateRk: '1bc7e79a9dd749fdb2a279f267aa8bee', enabled: true },
    ],
    commonFiles: [],
    contractsFiles: [
        { templateRk: '5b60679c82674581b546a298b04842c9', enabled: true },
        { templateRk: '48d02bdd0d724cf2b39acaaa6bc63381', enabled: true },
        { templateRk: '3f9ff3deb1684f398a5901cce77bdc53', enabled: true },
        { templateRk: 'dbff988a65324801b0a0ef482253bc1d', enabled: true },
        { templateRk: '8eec99ae1d6e4b2a8c7413617280920a', enabled: true },
        { templateRk: 'd3c9ebf317364f2f897bccde8e1233af', enabled: true },
        { templateRk: '27a47d5914394d75a43c7af0b2f01e15', enabled: true },
        { templateRk: 'fef875952108430a9eea02c4af4b8866', enabled: true },
        { templateRk: '22157487cae94c5eb59ba5fac5caa6e6', enabled: true },
        { templateRk: '0daebdb384c841579705abefc3a33e28', enabled: true },
        { templateRk: 'b5d56b636c914e04ba366520670e0337', enabled: true },
    ],
    testsFiles: [
        { templateRk: 'edcbef3438bc4854a14d649039b725d6', enabled: true },
        { templateRk: 'dd2602057e1749b6ac41e21a5b305400', enabled: true },
    ],
};
